export const COMPATIBLE_ACTION_SETS_ALERT_DISMISSED = 'Workflows:alert:CompatibleActionSetsAlertDismissed';
export const USER_ATTRIBUTE_HIDE_AI_NEXT_ACTION_RECOMMENDATIONS = 'Workflows:Canvas:Ai:NextActionRecommendations:hide';